import { LightForm, LightMaterial, LightCalculationResult, LightCalculationPayload } from "./types";
import { buildApiUrl } from "../config/api";

const qs = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : new URLSearchParams();
const DEFAULT_PARTNER_ID = qs.get("partnerId") || "mondial";
// Fallback token pour l'environnement light (aligné sur config/partners/mondial.json)
const DEFAULT_PARTNER_TOKEN = qs.get("token") || process.env.REACT_APP_LIGHT_PARTNER_TOKEN || "dev-partner-token";
const withBase = (path: string) => buildApiUrl(path);

async function request<T>(
  url: string,
  options: RequestInit = {},
  partnerId = DEFAULT_PARTNER_ID,
  partnerToken = DEFAULT_PARTNER_TOKEN,
): Promise<T> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "X-Partner-Id": partnerId,
  };
  if (partnerToken) {
    headers["X-Partner-Token"] = partnerToken;
  }
  if (options.headers) {
    Object.assign(headers, options.headers as Record<string, string>);
  }
  const res = await fetch(url, { ...options, headers });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export function fetchForms(
  partnerId?: string,
  partnerToken?: string,
): Promise<{ forms: LightForm[]; mode: string; partnerId: string }> {
  return request(withBase(`/light/forms`), {}, partnerId, partnerToken);
}

export function fetchMaterials(
  partnerId?: string,
  partnerToken?: string,
): Promise<{ materials: LightMaterial[]; partnerId: string }> {
  return request(withBase(`/light/materials`), {}, partnerId, partnerToken);
}

export function calculer(
  payload: LightCalculationPayload,
  partnerId?: string,
  partnerToken?: string,
): Promise<LightCalculationResult> {
  const body: any = {};
  body.partnerId = payload.partnerId || partnerId || DEFAULT_PARTNER_ID;
  if (payload.articles) {
    body.laize = payload.laize;
    body.articles = payload.articles;
  } else {
    // compat V1
    body.laize = payload.laize;
    body.forme = payload.forme;
    body.dimensions = payload.dimensions;
    body.matiere = payload.matiere;
    body.quantite = payload.quantite || 1;
    body.options = payload.options;
  }
  return request(
    withBase(`/light/devis/calculer`),
    { method: "POST", body: JSON.stringify(body) },
    body.partnerId,
    partnerToken || DEFAULT_PARTNER_TOKEN,
  );
}
